<div class="roomLegendForSessionSelection">
	@if (visibleLegendItems.readyToConnect) {
		<div class="colorLegendCon">
			<div class="indicator ready">
				<i class="fad fa-check-double"></i>
			</div>
			<div class="text">
				{{ T.PLAYER_STATUS_READY_TO_CONNECT | translate }}
			</div>
		</div>
		<div class="colorSeperator"></div>
	}

	@if (visibleLegendItems.offline) {
		<div class="colorLegendCon">
			<div class="indicator offline">
				<i class="fad fa-wifi-slash"></i>
			</div>
			<div class="text">{{ T.PLAYER_STATUS_OFFLINE | translate }}</div>
		</div>
		@if (visibleLegendItems.occupied || visibleLegendItems.debriefing) {
			<div class="colorSeperator"></div>
		}
	}

	@if (visibleLegendItems.debriefing) {
		<div class="colorLegendCon">
			<div class="indicator debriefing">
				<i class="fad fa-signal-stream"></i>
			</div>
			<div class="text">
				{{ T.PLAYER_STATUS_USED_IN_DEBRIEFING | translate }}
			</div>
		</div>
		@if (visibleLegendItems.occupied) {
			<div class="colorSeperator"></div>
		}
	}

	@if (visibleLegendItems.occupied) {
		<div class="colorLegendCon">
			<div class="indicator occupied">
				<i class="fad fa-digging"></i>
			</div>
			<div class="text">
				{{ T.PLAYER_STATUS_ROOM_OCCUPIED | translate }}
			</div>
		</div>
	}
</div>
